import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import createSigningDocuments from "../graph-ql/createSigningDocuments.graphql";

const useMutationCreateSigningdocuments = (
  agreementKey: string,
  { onCompleted, onError }: MutationHookOptions,
) =>
  useMutation(createSigningDocuments, {
    variables: { agreementKey },
    onCompleted,
    onError,
  });

export default useMutationCreateSigningdocuments;
